export const BROADCAST_MESSAGE_SEPARATOR = '::';

export const buildBroadcastMessage = (...args: Array<string>) => args.join(BROADCAST_MESSAGE_SEPARATOR);
